/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { isGuid } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";

export const useWebpageSDK = () => {

    const readNode = async function (webpage) {
        if (!webpage) {
            return;
        }
        return {
            guid: webpage?.guid,
            path: webpage?.path,
            nav_title: webpage?.nav_title,
            banner_image: webpage?.banner_image,
            icon: webpage?.icon,
            slug: webpage?.slug,
            shortlink: webpage?.shortlink,
            description: webpage?.description,
            children: webpage?.children,
            parent: webpage?.parent,
        };
    };

    const fetchWebpageTree = async (token, webpage_id) => {
        let webpage, error;
        try {
            if (isGuid(webpage_id)) {
                const response = await SimpliCityAdminSDK.webpage.findTree(token, webpage_id);
                if (response) {
                    webpage = await readNode(response);
                    return { webpage, error };
                } else {
                    throw Error("Failed to return webpage tree.");
                }
            } else {
                throw Error("Webpage guid was invalid. Could not return webpage tree.");
            }
        } catch (error) {
            Logger.error(error);
            return { error, webpage };
        }
    };

    const fetchWebpageChildren = async (token, webpage_guid) => {
        let webpage, error;
        try {
            if (isGuid(webpage_guid)) {
                const response = await SimpliCityAdminSDK.webpage.findChildren(token, webpage_guid);
                if (response) {
                    webpage = await readNode(response);
                    return { webpage, error };
                } else {
                    throw Error("Failed to return webpage children.");
                }
            } else {
                throw Error("Webpage guid was invalid. Could not return webpage children.");
            }
        } catch (error) {
            Logger.error(error);
            return { error, webpage };
        }
    };

    return {
        fetchWebpageTree,
        fetchWebpageChildren,
    };
};
